/**
 * Shared enquiry type used by branch dropdown consumers across legacy and current flows.
 */
export interface DropdownItem<T> {
    header: string;
    value: T;
    selected?: boolean;
}

/**
 * The source of the enquiry. Used in the following tracking events:
 * - `EnquiryReveal`
 * - `EnquiryEngagement`
 * - `SubmitCreateEnquiryRequest`
 * - `CreatedEnquiry`
 */
/**
 * Every surface an enquiry can start from. Single source of truth: the runtime
 * array backs both the type and the session validator's enum, which used to be
 * two hand-maintained lists that drifted.
 */
export const CREATE_ENQUIRY_SOURCES = [
    'EnquiryModal',
    'InPage',
    'ProfessionalIsland',
    'ProductIsland',
    'ProjectIsland',
    'ProjectTeam',
    'ProjectTeamSection',
    'ProjectDetail',
    'ProjectMobileCTA',
    'ProjectAboutProfessional',
    'ProductHeaderCTA',
    'ProductDetailsCTA',
    'ProductPhotoViewer',
    'ProductMobileCTA',
    'ProfessionalHeader',
    'ProfessionalOverview',
    'ProfessionalAboutTab',
    'ProfessionalLocationDetail',
    'ProfessionalLocationMap',
    'ProfessionalContactSection',
    'ProfessionalContactTab',
    'ProfessionalStickyCTA',
] as const;

export type CreateEnquirySource = (typeof CREATE_ENQUIRY_SOURCES)[number];
